export const DynamicComponentsList = [
  { name: "Chart" },
  { name: "CustomForm" },
  { name: "MockUI" },
  { name: "CustomCode" },
];
export const eleAtrribute = {};
